var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Vue, } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import election from '../services/election';
import authService from '../services/auth';
var alertStore = namespace('Alert');
var Dashboard = /** @class */ (function (_super) {
    __extends(Dashboard, _super);
    function Dashboard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingComplete = false;
        _this.participantElections = [];
        _this.adminElections = [];
        _this.user = '';
        _this.authObserver = null;
        return _this;
    }
    Dashboard.prototype.created = function () {
        return __awaiter(this, void 0, void 0, function () {
            var onUserLoaded;
            var _this = this;
            return __generator(this, function (_a) {
                onUserLoaded = function (user) { return __awaiter(_this, void 0, void 0, function () {
                    var promises, _a, _b, e_1;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0:
                                this.user = user;
                                _c.label = 1;
                            case 1:
                                _c.trys.push([1, 4, , 5]);
                                promises = [
                                    election.getAdminElections(user),
                                    election.getParticipantElections(user)
                                ];
                                _a = this;
                                return [4 /*yield*/, promises[0]];
                            case 2:
                                _a.adminElections = _c.sent();
                                _b = this;
                                return [4 /*yield*/, promises[1]];
                            case 3:
                                _b.participantElections = _c.sent();
                                return [3 /*break*/, 5];
                            case 4:
                                e_1 = _c.sent();
                                this.displayAlert("Error loading elections: ".concat(e_1));
                                console.error(e_1);
                                return [3 /*break*/, 5];
                            case 5:
                                this.loadingComplete = true;
                                return [2 /*return*/];
                        }
                    });
                }); };
                this.authObserver = authService.observeAuth()
                    .subscribe(function (currentUser) { return __awaiter(_this, void 0, void 0, function () {
                    var e_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                console.log('Dashboard event: ', currentUser === null || currentUser === void 0 ? void 0 : currentUser.uid, currentUser === null || currentUser === void 0 ? void 0 : currentUser.isAnonymous);
                                if (!currentUser) {
                                    return [2 /*return*/];
                                }
                                if (currentUser.isAnonymous) {
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, onUserLoaded(currentUser.uid)];
                            case 2:
                                _a.sent();
                                return [3 /*break*/, 4];
                            case 3:
                                e_2 = _a.sent();
                                console.warn("Failed to load elections ".concat(e_2));
                                return [3 /*break*/, 4];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); }, function (error) {
                    console.warn("subscribe error ".concat(error));
                });
                return [2 /*return*/];
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    Dashboard.prototype.openElection = function (electionId) {
        this.$router.push({ name: 'election', params: { id: electionId } });
    };
    __decorate([
        alertStore.Action
    ], Dashboard.prototype, "displayAlert", void 0);
    __decorate([
        alertStore.Action
    ], Dashboard.prototype, "hideAlert", void 0);
    Dashboard = __decorate([
        Component
    ], Dashboard);
    return Dashboard;
}(Vue));
export default Dashboard;
